import { createContext, useContext } from 'react';

export type ScrollbarContextProps = {
    scrollToTop: () => void;
};

const ScrollbarContext = createContext<ScrollbarContextProps>({
    scrollToTop: () => {},
});

export const useScrollbar = () => useContext(ScrollbarContext);

export default ScrollbarContext;
